import React from 'react'
import ExchangePageComponent from '../components/exchange'

function ExchangePage() {
  return (
    <div className='px-4'><ExchangePageComponent/></div>
  )
}

export default ExchangePage